import {
  SignalsPageContent,
  SignalsPageProvider,
} from '@/features/(signal)/signals';

export const SignalsPage = () => {
  return (
    <SignalsPageProvider>
      <SignalsPageContent />
    </SignalsPageProvider>
  );
};
